import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useCurrentUserId } from '#src/app/shared/hooks/session';
import type { ShareAction } from '#src/app/shared/hooks/share';
import { useAvailableShareActions } from '#src/app/shared/hooks/share';

type Channel = 'qrcode';
const CHANNELS: readonly Channel[] = ['qrcode'];

export function useQRCodeShare(): ShareAction<Channel> {
	const { data } = useStarterDashboardV2PageData();
	const sourceLocation = useQueryParamValue('source_location');
	const currentUserId = useCurrentUserId();

	const getTrackingData = useCallback(
		(_channel: Channel) => ({
			view_context: 'starter_dashboard',
			own_petition: data.petition.user.id === currentUserId,
			context: 'starter_dashboard',
			petition_id: `petition_${data.petition.id}`,
			source_location: sourceLocation,
		}),
		[currentUserId, data.petition.id, data.petition.user.id, sourceLocation],
	);

	// We only use the share action helper to handle the share tracking.
	// The short URL is built by the QR generator in GraphQL.
	return useAvailableShareActions(CHANNELS, {
		trackingEventName: 'share_petition',
		getUrl: (_channel: Channel) => '',
		getTrackingData,
		getContent: (_channel: Channel) => '',
		disableShortLinks: true,
	})[0];
}
